import { IUserSubMenu } from '../UserSubMenus';
import { SettingHeaderItem } from './SettingsHeaderItem';
import { Icon, IconType } from '@repo/ui/components';

export interface ISettingsHeaderProps {
  selected?: IUserSubMenu;

  onReset(): void;
  onClose(): void;
}

export const SettingsHeader = (props: ISettingsHeaderProps) => (
  <div className="py-3 px-5 flex justify-between items-center bg-indigo70">
    {!props.selected && <div className="text-xs/[170%] font-extrabold">Innstillinger</div>}
    {props.selected && <SettingHeaderItem item={props.selected} key={props.selected.key} onReset={props.onReset} />}
    <button
      className="h-full bg-transparent text-black opacity-100 cursor-pointer"
      onClick={() => {
        props.onClose();
      }}
    >
      <Icon icon={IconType.NewNextCross} height={24} width={24} aria-hidden />
    </button>
  </div>
);
